import { useRef, useState } from "react";
import { LogOut } from "lucide-react";
import { Button } from "@/shared/components/shadcn/Button";

interface SignOutButtonProps {
  signOut: () => Promise<void>;
}

export function SignOutButton({ signOut }: SignOutButtonProps) {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [error, setError] = useState("");
  const loggingOut = useRef(false);

  const handleLogout = async () => {
    if (loggingOut.current) return;
    loggingOut.current = true;
    setIsLoggingOut(true);
    setError("");
    try {
      await signOut();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Unable to log out. Please try again.");
    } finally {
      loggingOut.current = false;
      setIsLoggingOut(false);
    }
  };

  return (
    <>
      {error && <p>Couldn't log out: {error}</p>}
      <Button type="button" variant="outline" disabled={isLoggingOut} onClick={() => void handleLogout()}>
        <LogOut aria-hidden="true" />
        {isLoggingOut ? "Logging out..." : "Logout"}
      </Button>
    </>
  );
}
